module.exports = __webpack_public_path__ + "038a3b79ea25b0c68fa240ff0906aea2.pdf";